import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a46945f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-input-container" }
const _hoisted_2 = {
  key: 0,
  ref: "titleRef",
  class: "title"
}
const _hoisted_3 = {
  key: 0,
  class: "required"
}
const _hoisted_4 = ["value", "disabled", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.title)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString($props.title), 1 /* TEXT */),
          ($props.required)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "*"))
            : _createCommentVNode("v-if", true)
        ], 512 /* NEED_PATCH */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass(["calendar-input-wrapper", { disabled: $props.disabled }])
    }, [
      _createElementVNode("button", {
        class: _normalizeClass(["calendar-input", { disabled: $props.disabled }]),
        type: "button",
        "aria-label": "달력 열기",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleCalendar(true)))
      }, [
        _createElementVNode("input", {
          class: "from-date",
          type: "text",
          value: $setup.formattedSelectedDate,
          readonly: "",
          disabled: $props.disabled,
          placeholder: $props.placeholder
        }, null, 8 /* PROPS */, _hoisted_4),
        _createVNode($setup["InlineSvg"], {
          class: "calendar-icon",
          src: require('@/assets/icons/calendar.svg'),
          alt: "calendar"
        }, null, 8 /* PROPS */, ["src"])
      ], 2 /* CLASS */)
    ], 2 /* CLASS */),
    ($setup.showCalendar)
      ? (_openBlock(), _createBlock($setup["Calendar"], {
          key: 1,
          initialSelectedDate: $props.selectedDate,
          titleHeight: $setup.titleHeight,
          hasTimeSelect: $props.hasTimeSelect,
          onOnSelectDate: $setup.onSelectDate,
          onOnClickClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleCalendar(false)))
        }, null, 8 /* PROPS */, ["initialSelectedDate", "titleHeight", "hasTimeSelect"]))
      : _createCommentVNode("v-if", true)
  ]))
}